export default ({ request }) => ({
  ecomAmzFirstDemandDashboardApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/dashboard',
      method: 'POST',
      data,
    })
  },
})
